import React, { useEffect } from 'react'
import { TrackEvent, useTracking } from './fa/common/tracking'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useDeleteRoomSessionMutation } from './fa/store/fa'
import { getRoomTrackingDetails } from './fa/tracking'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { RoomSession } from '../../models/Room'
interface DeleteRoomSessionModalProps {
  roomSession: RoomSession
  show: boolean
  onSessionDeleted: () => void
  onHide: () => void
}

export const DeleteRoomSessionModal: React.FC<DeleteRoomSessionModalProps> = ({ roomSession, show, onSessionDeleted, onHide }) => {
  const { tracked } = useTracking()
  const accountId = useAppSelector(selectAccountId)

  const [deleteSession, { isLoading, error, isSuccess }] = useDeleteRoomSessionMutation()
  const _onSessionDelete = () => {
    deleteSession({
      accountId,
      roomId: roomSession.roomId,
      sessionId: roomSession.id,
    })
  }

  useEffect(() => {
    if (isSuccess) {
      onSessionDeleted()
    }
  }, [isSuccess])

  const onSessionDelete = tracked(_onSessionDelete, {
    eventName: TrackEvent.ROOM_SESSION_DELETED,
    eventDetails: getRoomTrackingDetails(roomSession),
  })

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete Meeting</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>Are you sure you want to delete meeting {roomSession.id} ?</div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={onSessionDelete}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    ></Modal>
  )
}
